import './index.styles.scss';
import './assets/css/bootstrap.min.css';
import './assets/css/nucleo-icons.css';
import './assets/scss/black-dashboard-pro-react.scss?v=1.0.0';
import './assets/demo/demo.css';
import 'react-notification-alert/dist/animate.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import aws_config from './aws-exports';
import Amplify from 'aws-amplify';
import ErrorBoundary from './components/ErrorBondary/ErrorBoundary';

declare global {
  interface ModuleConfig {
    INITIAL_MEMORY?: number;
    ALLOW_MEMORY_GROWTH?: boolean;
  }

  interface Window {
    Module?: ModuleConfig;
  }
}

const config = aws_config;
if (
  window.location.href.includes('/external') ||
  window.location.href.includes('/confirm-receipt') ||
  window.location.href.includes('/sign-document')
) {
  config.aws_appsync_authenticationType = 'API_KEY';
} else {
  config.aws_appsync_authenticationType = 'AMAZON_COGNITO_USER_POOLS';
}

Amplify.configure(config);

window.Module = {
  INITIAL_MEMORY: 268435456,
  ALLOW_MEMORY_GROWTH: true,
};

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root'),
);
